// The composer's textarea id; Reply focuses it by id.
export const NOTE_INPUT_ID = 'add-note-input'
